// src/components/VideoPlayer.jsx
import { useEffect, useRef } from 'react';

export default function VideoPlayer({ src, autoPlay = true }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (autoPlay) {
      video.currentTime = 0;
      video.play().catch((err) => console.warn('Autoplay error:', err));
    }

    return () => {
      video.pause();
      video.currentTime = 0;
    };
  }, [src, autoPlay]);

  return (
    <video
      ref={videoRef}
      className="w-full h-auto"
    //   controls
      preload="auto"
    >
      <source src={src} type="video/mp4" />
      Tu navegador no soporta video HTML5.
    </video>
  );
}
